import * as React from 'react';
import { SVGProps } from 'react';

const SvgPen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M20.068 8.242 9.242 19.068H5v-4.242L15.826 4l4.242 4.242ZM6.5 15.447v2.121h2.122l7.21-7.21-2.122-2.122-7.21 7.211Zm8.27-8.271 2.122 2.12 1.055-1.054-2.12-2.12-1.056 1.054Z"
    />
  </svg>
);

export default SvgPen;
